<template>
  <VLayout
    row
    wrap
  >
    <VFlex
      xs12
      sm12
    >
      <NewVDataTable
        :items="filtered"
        :headers="headers"
        item-key="id-eventDate-loss_reason"
        class="elevation-1"
        @update:limit="e => $emit('limit', e)"
      >
        <template
          slot="items"
          slot-scope="{item}"
        >
          <td
            v-if="undefined !== item.eventDate"
            class="text-xs-left"
          >
            {{ item.eventDate }}
          </td>
          <td
            v-if="undefined !== item.country"
            class="text-xs-left"
          >
            {{ getCountryName(item.country) }}
          </td>
          <td
            v-if="undefined !== item.device"
            class="text-xs-left"
          >
            {{ item.device|capitalize }}
          </td>
          <td
            v-if="undefined !== item.os"
            class="text-xs-left"
          >
            {{ showOsName(item.os) }}
          </td>
          <td
            v-if="undefined !== item.browser"
            class="text-xs-left"
          >
            {{ item.browserName || item.browser }}
          </td>
          <td
            v-if="undefined !== item.loss_reason
              && !isHidden('loss_reason')"
            class="text-xs-left"
          >
            {{ item.loss_reason|lossReasonName }}
          </td>
          <td
            v-if="undefined !== item.siteId"
            class="text-xs-left"
          >
            {{ item.siteId }}
          </td>
          <td
            v-if="undefined !== item.domain"
            class="text-xs-left"
          >
            {{ item.domain }}
          </td>
          <td
            v-if="undefined !== item.crid"
            class="text-xs-left"
          >
            {{ item.crid }}
          </td>
          <td
            v-if="undefined !== item.requests && !isHidden('requests')"
            class="text-xs-left"
          >
            {{ item.requests| roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.responses && !isHidden('responses')"
            class="text-xs-left"
          >
            {{ item.responses| roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.winRate"
            class="text-xs-left"
          >
            {{ item.winRate|roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.wins && !isHidden('wins')"
            class="text-xs-left"
          >
            {{ item.wins|roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.responseRate"
            class="text-xs-left"
          >
            {{ item.responseRate | roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.spent && !isHidden('spent')"
            class="text-xs-left"
          >
            {{ item.spent | roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.avgCPM && !isHidden('avgCPM')"
            class="text-xs-left"
          >
            {{ item.avgCPM | roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.clicks && !isHidden('clicks')"
            class="text-xs-left"
          >
            {{ item.clicks| roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.ctr && !isHidden('ctr')"
            class="text-xs-left"
          >
            {{ item.ctr| roundFormatter }}
          </td>
          <td
            v-if="undefined !== item.cpc && !isHidden('cpc')"
            class="text-xs-left"
          >
            {{ item.cpc| roundFormatter }}
          </td>
        </template>
        <template slot="footer">
          <td v-if="filtered[0] && undefined !== filtered[0].eventDate" />
          <td v-if="filtered[0] && undefined !== filtered[0].country" />
          <td v-if="filtered[0] && undefined !== filtered[0].device" />
          <td v-if="filtered[0] && undefined !== filtered[0].os" />
          <td v-if="filtered[0] && undefined !== filtered[0].browser" />
          <td
            v-if="filtered[0] && undefined !== filtered[0].loss_reason
              && !isHidden('loss_reason')"
          />
          <td v-if="filtered[0] && undefined !== filtered[0].siteId" />
          <td v-if="filtered[0] && undefined !== filtered[0].domain" />
          <td v-if="filtered[0] && undefined !== filtered[0].crid" />
          <td
            v-if="undefined !== summary.requests && !isHidden('requests')"
            class="text-xs-left"
          >
            <strong>{{ summary.requests| roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.responses && !isHidden('responses')"
            class="text-xs-left"
          >
            <strong>{{ summary.responses| roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.winRate"
            class="text-xs-left"
          >
            <strong>{{ summary.winRate| roundFormatter }} </strong>
          </td>
          <td
            v-if="undefined !== summary.wins && !isHidden('wins')"
            class="text-xs-left"
          >
            <strong>{{ summary.wins| roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.responseRate"
            class="text-xs-left"
          >
            <strong>{{ summary.responseRate| roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.spent && !isHidden('spent')"
            class="text-xs-left"
          >
            <strong>{{ summary.spent | roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.avgCPM && !isHidden('avgCPM')"
            class="text-xs-left"
          >
            <strong>{{ summary.avgCPM| roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.clicks && !isHidden('clicks')"
            class="text-xs-left"
          >
            <strong>{{ summary.clicks| roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.ctr && !isHidden('ctr')"
            class="text-xs-left"
          >
            <strong>{{ summary.ctr| roundFormatter }}</strong>
          </td>
          <td
            v-if="undefined !== summary.cpc && !isHidden('cpc')"
            class="text-xs-left"
          >
            <strong>{{ summary.cpc| roundFormatter }}</strong>
          </td>
        </template>
      </NewVDataTable>
    </VFlex>
  </VLayout>
</template>

<script>
import NewVDataTable from '@/app/components/VDataTable';
import lossReasonName from '@/app/filters/loss-reasons.js';
import i18n from '@/plugins/i18n';
import { mapGetters, mapActions } from 'vuex';
import filtering from '../statistic/dataFilter';
import calculateSummary from './summary.js';


export default {
  name: 'StatisticTable',
  components: {
    NewVDataTable,
  },
  filters: {
    lossReasonName,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    compare: {
      type: Object,
      default: () => {},
    },
    limit: {
      type: Number,
      default: () => 2000,
    },
    hidden: {
      type: Array,
      default: () => ['loss_reason'],
    },
    allHeaders: {
      type: Array,
      default: () => [
        {
          text: i18n.t('statistic.eventDate'), value: 'eventDate', sortable: true,
        },
        {
          text: i18n.t('form.country'), value: 'country', sortable: true,
        },
        {
          text: i18n.t('headers.device'), value: 'device', sortable: true,
        },
        {
          text: i18n.t('headers.os'), value: 'os', sortable: true,
        },
        {
          text: i18n.t('form.browser'), value: 'browser', sortable: true,
        },

        {
          text: i18n.t('statistic.loss_reason'), value: 'loss_reason', sortable: true,
        },
        {
          text: i18n.t('form.siteId'), value: 'siteId', sortable: true,
        },
        {
          text: i18n.t('statistic.domain'), value: 'domain', sortable: true,
        },
        {
          text: i18n.t('statistic.crid'), value: 'crid', sortable: true,
        },
        {
          text: i18n.t('statistic.requests'), value: 'requests', sortable: true,
        },
        { text: i18n.t('statistic.responses'), value: 'responses', sortable: true },
        { text: i18n.t('statistic.winRate'), value: 'winRate', sortable: true },
        { text: i18n.t('statistic.wins'), value: 'wins', sortable: true },
        { text: i18n.t('statistic.responseRate'), value: 'responseRate', sortable: true },
        { text: i18n.t('statistic.spent'), value: 'spent', sortable: true },
        { text: i18n.t('statistic.avgCPM'), value: 'avgCPM', sortable: true },
        { text: i18n.t('statistic.clicks'), value: 'clicks', sortable: true },
        { text: i18n.t('statistic.ctr'), value: 'ctr', sortable: true },
        { text: i18n.t('statistic.cpc'), value: 'cpc', sortable: true },
      ],
    },
  },
  computed: {
    ...mapGetters('dictionary', [
      'countries', 'os',
    ]),
    summary() {
      return calculateSummary(this.filtered);
    },
    headers() {
      if (this.items.length === 0) {
        return [];
      }
      const show = Object.keys(this.items[0]);
      const headers = this.allHeaders
        .filter(({ value }) => show.includes(value))
        .filter(({ value }) => !this.hidden.includes(value));

      this.$emit('headers', headers);

      return headers;
    },
    filtered() {
      return filtering(this.items, this.hidden, this.compare);
    },
  },
  created() {
    this.loadOs();
  },
  methods: {
    ...mapActions('dictionary', ['loadOs']),
    isHidden(key) {
      return this.hidden.includes(key);
    },
    getCountryName(id) {
      const country = (this.countries || []).find(item => item.id === id);
      if (!country) {
        return id;
      }

      return country.name;
    },
    showOsName(uid) {
      const os = this.os.find(item => item.uid === uid);
      if (os) {
        return os.platform;
      }
      return uid;
    },
  },
};
</script>
